import { render, staticRenderFns } from "./DirectorySpotsTable.vue?vue&type=template&id=d9ca633e&scoped=true&lang=html&"
import script from "./DirectorySpotsTable.vue?vue&type=script&lang=ts&"
export * from "./DirectorySpotsTable.vue?vue&type=script&lang=ts&"
import style0 from "./DirectorySpotsTable.vue?vue&type=style&index=0&id=d9ca633e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ca633e",
  null
  
)

export default component.exports